/**
 * Utility class to generate a QR code img element which is placed
 * under a parent element.
 *
 * Relies upon a script element in the page:
 *
 * <script src='https://unpkg.com/qrcode-generator@1.4.4/qrcode.js'>
 */
const QrType = 0 // Auto detection by library.
const QrEcc = 'L'

export const ImgClass = 'qrcode'

export class QrCode {
  #img
  #content

  /**
   * Constructor takes img element and
   * the string to show in the QR code.
   * @param {HTMLImageElement} img the image element to use.
   * @param {string} content the content of the qr code.
   */
  constructor(img, content) {
    this.#img = img
    this.#content = content
  }

  /**
   * Returns a promise that is resolved when the image loads
   * successfully, or rejected if the image load fails.
   */
  generate() {
    const qr = qrcode(QrType, QrEcc)
    qr.addData(this.#content)
    qr.make()
    const dataUrl = qr.createDataURL()
    this.#img.classList.add(ImgClass)
    this.#img.src = dataUrl
    return new Promise((resolve, reject) => {
      this.#img.onload = resolve
      this.#img.onerror = reject
    })
  }
}
